<template>
  <div class="p2p-page narrow">
    <section class="p2p-hero">
      <h1 class="p2p-h1">{{ title }}</h1>
      <p class="p2p-lead">{{ detail }}</p>
      <div v-if="done" class="p2p-row" style="justify-content:center">
        <router-link :to="back" class="p2p-btn">Continue</router-link>
        <router-link to="/connections" class="p2p-btn outline">Manage connections</router-link>
      </div>
    </section>
  </div>
</template>

<script>
import { post, message } from '../api';

export default {
  name: 'ConnectCallback',
  data: () => ({ title: 'Connecting your account…', detail: 'Checking the connection with the network.', done: false, back: '/connections' }),
  async mounted() {
    const query = this.$route.query;
    const stored = sessionStorage.getItem('p2p-connect-return');
    this.back = stored && stored.charAt(0) === '/' && stored.charAt(1) !== '/' ? stored : '/connections';
    sessionStorage.removeItem('p2p-connect-return');
    try {
      const result = await post('/social/complete', {
        provider: String(query.provider || ''), is_success: String(query.isSuccess) === 'true',
        account_ids: String(query.accountIds || '').split(',').map(item => item.trim()).filter(Boolean),
        error: String(query.error || '')
      });
      if (result.connected.length) {
        this.title = result.connected.length === 1 ? 'Account connected' : result.connected.length + ' accounts connected';
        this.detail = 'You can publish to ' + (result.connected.length === 1 ? 'it' : 'them') + ' now.';
        await this.$store.dispatch('publisher/loadAccounts');
        const target = this.back === '/connections' ? { path: '/connections', query: { connected: String(result.connected.length) } } : this.back;
        this.$router.replace(target).catch(() => {});
      } else {
        this.title = 'Nothing was connected';
        this.detail = result.message || 'Please try again and approve the connection.';
      }
    } catch (error) {
      this.title = 'The connection could not be confirmed';
      this.detail = message(error);
    }
    this.done = true;
  }
};
</script>
